export default __webpack_public_path__ + "static/media/sort.c86556e0.svg";